/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Seating_Violates_R1Inputs */



/**
* | output |
* | --- |
* | "Seating violates R1 (predator-prey repeat)" |
*
* @param {Err_Tournament_Seating_Violates_R1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_seating_violates_r1 = /** @type {((inputs?: Err_Tournament_Seating_Violates_R1Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Seating_Violates_R1Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le placement viole R1 (répétition prédateur-proie)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los asientos violan R1 (repetición depredador-presa)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os assentos violam R1 (repetição predador-presa)")
	if (locale === "it") return /** @type {LocalizedString} */ ("La disposizione viola R1 (ripetizione predatore-preda)")
	return /** @type {LocalizedString} */ ("Seating violates R1 (predator-prey repeat)")
});